import { userMeQuery } from '~/util/queries/public/users';
// @ts-expect-error no types
import 'react-color-palette/css';
import { ScrollArea } from '~/primitives/scroll-area';
import ClanSettings from './-ClanSettings';
import ClanSelect from './-ClanSelect';
import { ExternalLink } from 'lucide-react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { seo } from '~/util';
import {
    clanInvitesQuery,
    clanMembersQuery,
} from '~/util/queries/public/clans';

export const Route = createFileRoute('/_authenticated/clan')({
    beforeLoad: async ({ context: { queryClient } }) => {
        return {
            user: await queryClient.fetchQuery(userMeQuery()),
        };
    },
    loader: async ({
        context: {
            queryClient,
            user: { clan, id },
        },
    }) => {
        const [members, invites] = await Promise.all([
            clan
                ? await queryClient.fetchQuery(
                      clanMembersQuery({ clanid: clan?.id }),
                  )
                : Promise.resolve([]),
            await queryClient.fetchQuery(clanInvitesQuery()),
        ]);

        return {
            clan,
            members,
            invites,
            authedMember: members.find((member) => member.id === id),
        };
    },
    head: () => ({
        meta: seo({
            title: 'Clan Settings',
            description: 'Join, create, and manage your AREDL clan',
        }),
    }),

    component: Settings,
});

function Settings() {
    const clan = Route.useLoaderData({ select: ({ clan }) => clan });
    return (
        <div className="w-full lg:h-[calc(100vh-150px)] bg-background-dark rounded-xl flex flex-col clamp-[p-4-8-clamp]">
            <ScrollArea>
                <h1 className="text-secondary-foreground clamp-[text-3xl-5xl-clamp] font-medium inline-flex">
                    Your clan{' '}
                    {clan && (
                        <Link
                            to={`/profile/clan/$clanid`}
                            params={{
                                clanid: clan?.id,
                            }}
                            className="flex items-center"
                        >
                            <ExternalLink
                                height={40}
                                width={40}
                                className="ml-1 cursor-pointer hover:text-primary transition-colors"
                            />
                        </Link>
                    )}
                </h1>
                <main>
                    {clan ? <ClanSettings {...clan} /> : <ClanSelect />}
                </main>
            </ScrollArea>
        </div>
    );
}
